import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { BillingService } from 'app/services/billing/billing.service';
import { Charge } from 'app/services/billing/billing.type';
import { PayInvoiceModalComponent } from './modals/pay-invoice-modal.component';

@Component({
    selector: 'payment-history',
    templateUrl: './payment-history.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule
    ]
})
export class PaymentHistoryComponent implements OnInit {
    charges: Charge[] = [];
    loading: boolean = false;

    constructor(
        private _matDialog: MatDialog,
        private _billingService: BillingService
    ) {}

    ngOnInit(): void {
        this.loadCharges();
    }

    loadCharges(): void {
        this.loading = true;
        this._billingService.getCharges().subscribe({
            next: (response) => {
                this.charges = response.data;
                this.loading = false;
            },
            error: () => {
                this.loading = false;
            }
        });
    }

    formatCurrency(value: number): string {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value / 100);
    }

    openPayInvoiceModal(invoice: Charge): void {
        const dialogRef = this._matDialog.open(PayInvoiceModalComponent, {
            autoFocus: false,
            disableClose: false,
            width: '95%',
            maxWidth: '450px',
            panelClass: 'custom-modal-container',
            data: { invoice }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result?.action === 'payment_generated') {
                this.loadCharges();
            }
        });
    }
}
